<template>
  <svg id="unemployed_ratio_chart" style="background-color: white"></svg>
</template>

<script>
import * as d3 from "d3";
export default {
  name: "UnemplyeeRatio",
  data: function () {
    return {
      chartData: null,
      keys: null,
      svg_unemployed_ratio: null,
      svg_unemployed_ratio_1991: null,
      svg_unemployed_ratio_2000: null,
      svg_unemployed_ratio_2010: null,
      svg_unemployed_ratio_2019: null,
      margin: null,
      width: null,
      height: null,
      color_for_unemployed_circle: null,
      g_unemployed_ratio_1991: null,
      g_unemployed_ratio_2000: null,
      g_unemployed_ratio_2010: null,
      g_unemployed_ratio_2019: null,
      radius_unemployed_1991: null,
      radius_unemployed_2000: null,
      radius_unemployed_2010: null,
      radius_unemployed_2019: null,
      space_unemployed: null,
      select_mode_1991: null,
      data_unemployed_1991: null,
      current_data_unemployed_1991: null,
      select_mode_2000: null,
      data_unemployed_2000: null,
      current_data_unemployed_2000: null,
      select_mode_2010: null,
      data_unemployed_2010: null,
      current_data_unemployed_2010: null,
      select_mode_2019: null,
      data_unemployed_2019: null,
      current_data_unemployed_2019: null,
      text_size: "13",
      opacity_value: "0.6",
    };
  },
  mounted() {
    this.margin = { top: 10, right: 10, bottom: 10, left: 10 };
    this.width = 320 - this.margin.left - this.margin.right;
    this.height = 400 - this.margin.top - this.margin.bottom;

    this.svg_unemployed_ratio_1991 = d3
      .select("#unemployed_ratio_chart")
      .attr("viewBox", `0 0 320 500`);
    this.svg_unemployed_ratio_2000 = d3
      .select("#unemployed_ratio_chart")
      .attr("viewBox", `0 0 320 500`);
    this.svg_unemployed_ratio_2010 = d3
      .select("#unemployed_ratio_chart")
      .attr("viewBox", `0 0 320 500`);
    this.svg_unemployed_ratio_2019 = d3
      .select("#unemployed_ratio_chart")
      .attr("viewBox", `0 0 320 500`);

    this.keys = ["unemployed", "employed"];
    this.color_for_unemployed_circle = d3
      .scaleOrdinal()
      // .domain(["unemployed", "employed"])
      .domain(this.keys)
      .range(["#b6c6f5", "#b6e5f5"]);

    this.g_unemployed_ratio_1991 = this.svg_unemployed_ratio_1991
      .append("g")
      .attr(
        "transform",
        "translate(" + this.width / 2 + "," + this.height / 1.3 + ")"
      );
    this.g_unemployed_ratio_2000 = this.svg_unemployed_ratio_2000
      .append("g")
      .attr(
        "transform",
        "translate(" + this.width / 2 + "," + this.height / 1.3 + ")"
      );
    this.g_unemployed_ratio_2010 = this.svg_unemployed_ratio_2010
      .append("g")
      .attr(
        "transform",
        "translate(" + this.width / 2 + "," + this.height / 1.3 + ")"
      );
    this.g_unemployed_ratio_2019 = this.svg_unemployed_ratio_2019
      .append("g")
      .attr(
        "transform",
        "translate(" + this.width / 2 + "," + this.height / 1.3 + ")"
      );
    this.radius_unemployed_1991 = 35;
    this.radius_unemployed_2000 = this.radius_unemployed_1991 * 2;
    this.radius_unemployed_2010 = this.radius_unemployed_1991 * 3;
    this.radius_unemployed_2019 = this.radius_unemployed_1991 * 4;
    this.space_unemployed = 2;

    this.svg_unemployed_ratio = d3
      .select("#unemployed_ratio_chart")
      .attr("viewBox", `0 0 320 500`);

    // add legend dot
    this.svg_unemployed_ratio
      .selectAll("mydots")
      .data(this.keys)
      .enter()
      .append("circle")
      .attr("cx", 30)
      .attr("cy", function (d, i) {
        return 80 + i * 25;
      }) // 100 is where the first dot appears. 25 is the distance between dots
      .attr("r", 7)
      .style("fill", (d) => {
        return this.color_for_unemployed_circle(d);
      });

    // // Add one dot in the legend for each name.
    this.svg_unemployed_ratio
      .selectAll("mylabels")
      .data(this.keys)
      .enter()
      .append("text")
      .attr("x", 45)
      .attr("y", function (d, i) {
        return 80 + i * 25;
      }) // 100 is where the first dot appears. 25 is the distance between dots
      .style("fill", (d) => {
        return this.color_for_unemployed_circle(d);
      })
      .text(function (d) {
        return d;
      })
      .attr("text-anchor", "left")
      .style("alignment-baseline", "middle")
      .style("font-size", "18");



        // add title
    this.svg_unemployed_ratio
      .append("text")
      .style("text-anchor", "middle")
      .style("font-size", "19")
      .style("opacity", "0.7")
      .attr("x", this.width / 2 + 5)
      .attr("y", "30")
      .style("font-weight", "700")
      .text("Unemployment of total labor force");

    this.loadUnemployedRatio1991();
    this.loadUnemployedRatio2000();
    this.loadUnemployedRatio2010();
    this.loadUnemployedRatio2019();
  },
  methods: {
    loadUnemployedRatio1991() {
      const API = this.$store.state.API;
      d3.csv(`${API}/affect/laborMarket/unemployed_ratio_1991.csv`).then(
        (d) => {
          var population_num_1991 = d.columns.slice(1);
          function trans_series(csv) {
            return csv.map((d) => ({
              name: d.country,
              // values: {'no_worker':+d.no_worker,'unemployed_15_64':+d.unemployed_15_64,'unemployed_65':+d.unemployed_65}
              values: population_num_1991.map((k) => +d[k]),
            }));
          }
          this.data_unemployed_1991 = trans_series(d);
          // console.log('data is',data_unemployed_1991)
          this.draw_unemployed_pie_chart_1991();
          // console.log("yayyyy")
        }
      );
    },
    loadUnemployedRatio2000() {
      const API = this.$store.state.API;
      d3.csv(`${API}/affect/laborMarket/unemployed_ratio_2000.csv`).then(
        (d) => {
          var population_num_2000 = d.columns.slice(1);
          function trans_series(csv) {
            return csv.map((d) => ({
              name: d.country,
              values: population_num_2000.map((k) => +d[k]),
            }));
          }
          this.data_unemployed_2000 = trans_series(d);
          this.draw_unemployed_pie_chart_2000();
        }
      );
    },
    loadUnemployedRatio2010() {
      const API = this.$store.state.API;
      d3.csv(`${API}/affect/laborMarket/unemployed_ratio_2010.csv`).then(
        (d) => {
          var population_num_2010 = d.columns.slice(1);
          function trans_series(csv) {
            return csv.map((d) => ({
              name: d.country,
              values: population_num_2010.map((k) => +d[k]),
            }));
          }
          this.data_unemployed_2010 = trans_series(d);
          this.draw_unemployed_pie_chart_2010();
        }
      );
    },
    loadUnemployedRatio2019() {
      const API = this.$store.state.API;
      d3.csv(`${API}/affect/laborMarket/unemployed_ratio_2019.csv`).then(
        (d) => {
          var population_num_2019 = d.columns.slice(1);
          function trans_series(csv) {
            return csv.map((d) => ({
              name: d.country,
              values: population_num_2019.map((k) => +d[k]),
            }));
          }
          this.data_unemployed_2019 = trans_series(d);
          this.draw_unemployed_pie_chart_2019();
        }
      );
    },
    select(mode) {
      if (mode === "#labor-japan-btn") {
        this.current_data_unemployed_1991 = JSON.parse(
          JSON.stringify(this.data_unemployed_1991[0].values)
        );
        this.current_data_unemployed_2000 = JSON.parse(
          JSON.stringify(this.data_unemployed_2000[0].values)
        );
        this.current_data_unemployed_2010 = JSON.parse(
          JSON.stringify(this.data_unemployed_2010[0].values)
        );
        this.current_data_unemployed_2019 = JSON.parse(
          JSON.stringify(this.data_unemployed_2019[0].values)
        );
      } else if (mode === "#labor-italy-btn") {
        this.current_data_unemployed_1991 = JSON.parse(
          JSON.stringify(this.data_unemployed_1991[1].values)
        );
        this.current_data_unemployed_2000 = JSON.parse(
          JSON.stringify(this.data_unemployed_2000[1].values)
        );
        this.current_data_unemployed_2010 = JSON.parse(
          JSON.stringify(this.data_unemployed_2010[1].values)
        );
        this.current_data_unemployed_2019 = JSON.parse(
          JSON.stringify(this.data_unemployed_2019[1].values)
        );
      } else if (mode === "#labor-france-btn") {
        this.current_data_unemployed_1991 = JSON.parse(
          JSON.stringify(this.data_unemployed_1991[2].values)
        );
        this.current_data_unemployed_2000 = JSON.parse(
          JSON.stringify(this.data_unemployed_2000[2].values)
        );
        this.current_data_unemployed_2010 = JSON.parse(
          JSON.stringify(this.data_unemployed_2010[2].values)
        );
        this.current_data_unemployed_2019 = JSON.parse(
          JSON.stringify(this.data_unemployed_2019[2].values)
        );
      } else if (mode === "#labor-spain-btn") {
        this.current_data_unemployed_1991 = JSON.parse(
          JSON.stringify(this.data_unemployed_1991[3].values)
        );
        this.current_data_unemployed_2000 = JSON.parse(
          JSON.stringify(this.data_unemployed_2000[3].values)
        );
        this.current_data_unemployed_2010 = JSON.parse(
          JSON.stringify(this.data_unemployed_2010[3].values)
        );
        this.current_data_unemployed_2019 = JSON.parse(
          JSON.stringify(this.data_unemployed_2019[3].values)
        );
      } else if (mode === "#labor-uk-btn") {
        this.current_data_unemployed_1991 = JSON.parse(
          JSON.stringify(this.data_unemployed_1991[4].values)
        );
        this.current_data_unemployed_2000 = JSON.parse(
          JSON.stringify(this.data_unemployed_2000[4].values)
        );
        this.current_data_unemployed_2010 = JSON.parse(
          JSON.stringify(this.data_unemployed_2010[4].values)
        );
        this.current_data_unemployed_2019 = JSON.parse(
          JSON.stringify(this.data_unemployed_2019[4].values)
        );
      } else if (mode === "#labor-canada-btn") {
        this.current_data_unemployed_1991 = JSON.parse(
          JSON.stringify(this.data_unemployed_1991[5].values)
        );
        this.current_data_unemployed_2000 = JSON.parse(
          JSON.stringify(this.data_unemployed_2000[5].values)
        );
        this.current_data_unemployed_2010 = JSON.parse(
          JSON.stringify(this.data_unemployed_2010[5].values)
        );
        this.current_data_unemployed_2019 = JSON.parse(
          JSON.stringify(this.data_unemployed_2019[5].values)
        );
      } else if (mode === "#labor-us-btn") {
        this.current_data_unemployed_1991 = JSON.parse(
          JSON.stringify(this.data_unemployed_1991[6].values)
        );
        this.current_data_unemployed_2000 = JSON.parse(
          JSON.stringify(this.data_unemployed_2000[6].values)
        );
        this.current_data_unemployed_2010 = JSON.parse(
          JSON.stringify(this.data_unemployed_2010[6].values)
        );
        this.current_data_unemployed_2019 = JSON.parse(
          JSON.stringify(this.data_unemployed_2019[6].values)
        );
      } else if (mode === "#labor-australia-btn") {
        this.current_data_unemployed_1991 = JSON.parse(
          JSON.stringify(this.data_unemployed_1991[7].values)
        );
        this.current_data_unemployed_2000 = JSON.parse(
          JSON.stringify(this.data_unemployed_2000[7].values)
        );
        this.current_data_unemployed_2010 = JSON.parse(
          JSON.stringify(this.data_unemployed_2010[7].values)
        );
        this.current_data_unemployed_2019 = JSON.parse(
          JSON.stringify(this.data_unemployed_2019[7].values)
        );
      } else if (mode === "#labor-china-btn") {
        this.current_data_unemployed_1991 = JSON.parse(
          JSON.stringify(this.data_unemployed_1991[8].values)
        );
        this.current_data_unemployed_2000 = JSON.parse(
          JSON.stringify(this.data_unemployed_2000[8].values)
        );
        this.current_data_unemployed_2010 = JSON.parse(
          JSON.stringify(this.data_unemployed_2010[8].values)
        );
        this.current_data_unemployed_2019 = JSON.parse(
          JSON.stringify(this.data_unemployed_2019[8].values)
        );
      } else if (mode === "#labor-turkey-btn") {
        this.current_data_unemployed_1991 = JSON.parse(
          JSON.stringify(this.data_unemployed_1991[9].values)
        );
        this.current_data_unemployed_2000 = JSON.parse(
          JSON.stringify(this.data_unemployed_2000[9].values)
        );
        this.current_data_unemployed_2010 = JSON.parse(
          JSON.stringify(this.data_unemployed_2010[9].values)
        );
        this.current_data_unemployed_2019 = JSON.parse(
          JSON.stringify(this.data_unemployed_2019[9].values)
        );
      } else if (mode === "#labor-mexico-btn") {
        this.current_data_unemployed_1991 = JSON.parse(
          JSON.stringify(this.data_unemployed_1991[10].values)
        );
        this.current_data_unemployed_2000 = JSON.parse(
          JSON.stringify(this.data_unemployed_2000[10].values)
        );
        this.current_data_unemployed_2010 = JSON.parse(
          JSON.stringify(this.data_unemployed_2010[10].values)
        );
        this.current_data_unemployed_2019 = JSON.parse(
          JSON.stringify(this.data_unemployed_2019[10].values)
        );
      } else if (mode === "#labor-finland-btn") {
        this.current_data_unemployed_1991 = JSON.parse(
          JSON.stringify(this.data_unemployed_1991[11].values)
        );
        this.current_data_unemployed_2000 = JSON.parse(
          JSON.stringify(this.data_unemployed_2000[11].values)
        );
        this.current_data_unemployed_2010 = JSON.parse(
          JSON.stringify(this.data_unemployed_2010[11].values)
        );
        this.current_data_unemployed_2019 = JSON.parse(
          JSON.stringify(this.data_unemployed_2019[11].values)
        );
      } else if (mode === "#labor-iceland-btn") {
        this.current_data_unemployed_1991 = JSON.parse(
          JSON.stringify(this.data_unemployed_1991[12].values)
        );
        this.current_data_unemployed_2000 = JSON.parse(
          JSON.stringify(this.data_unemployed_2000[12].values)
        );
        this.current_data_unemployed_2010 = JSON.parse(
          JSON.stringify(this.data_unemployed_2010[12].values)
        );
        this.current_data_unemployed_2019 = JSON.parse(
          JSON.stringify(this.data_unemployed_2019[12].values)
        );
      } else if (mode === "#labor-chile-btn") {
        this.current_data_unemployed_1991 = JSON.parse(
          JSON.stringify(this.data_unemployed_1991[13].values)
        );
        this.current_data_unemployed_2000 = JSON.parse(
          JSON.stringify(this.data_unemployed_2000[13].values)
        );
        this.current_data_unemployed_2010 = JSON.parse(
          JSON.stringify(this.data_unemployed_2010[13].values)
        );
        this.current_data_unemployed_2019 = JSON.parse(
          JSON.stringify(this.data_unemployed_2019[13].values)
        );
      }
      this.select_mode_2000 = mode;
    },
    redraw_unemployed_pie_chart_1991() {
      // this.color_for_unemployed_circle = d3
      //   .scaleOrdinal()
      //   .domain(["no_worker", "unemployed_15_64", "unemployed_65"])
      //   .range(["#D8F3D0", "#B0E7DF", "#8BCDD3"]);
      // console.log("data1991: ", this.current_data_unemployed_1991);

      var arc = d3
        .arc()
        .outerRadius(this.radius_unemployed_1991)
        .innerRadius(this.space_unemployed);

      var pie = d3.pie().sort(null);
      this.g_unemployed_ratio_1991.selectAll(".arc1991").remove();
      this.g_unemployed_ratio_1991.selectAll(".arc1991text").remove();

      var path_unemployed_pie_chart_1991 = this.g_unemployed_ratio_1991
        .selectAll(".arc1991")
        .data(pie(this.current_data_unemployed_1991));
      path_unemployed_pie_chart_1991
        .enter()
        .append("g")
        .attr("class", "arc1991")
        .append("path")
        .style("fill", (d, i) => {
          return this.color_for_unemployed_circle(i);
        })
        .transition()
        .delay(function (d, i) {
          return i * 300;
        })
        .duration(300)
        .attrTween("d", function (d) {
          var i = d3.interpolate(d.startAngle + 0.01, d.endAngle);
          return function (t) {
            d.endAngle = i(t);
            return arc(d);
          };
        });

      this.g_unemployed_ratio_1991
        .selectAll(".arc1991text")
        .data(pie(this.current_data_unemployed_1991))
        .enter()
        .append("g")
        .attr("class", "arc1991text")
        .append("text")
        .transition()
        .delay(function (d, i) {
          return i * 300;
        })
        .text(function (d) {
          return `${d.value.toPrecision(3)}%`;
        })
        .attr("transform", function (d) {
          return "translate(" + arc.centroid(d) + ")";
        })
        .style("text-anchor", "middle")
        .style("font-size", this.text_size)
        .style("opacity", this.opacity_value);

      this.g_unemployed_ratio_1991
        .exit()
        .transition() //🚧  explain
        .duration(750) //🚧  explain
        .style("opacity", 0) //🚧  explain
        .remove(); //🚧  explain
    },

    draw_unemployed_pie_chart_1991() {
      // this.color_for_unemployed_circle = d3
      //   .scaleOrdinal()
      //   .domain(["no_worker", "unemployed_15_64", "unemployed_65"])
      //   .range(["#D8F3D0", "#B0E7DF", "#8BCDD3"]);
      var arc = d3
        .arc()
        .outerRadius(this.radius_unemployed_1991)
        .innerRadius(this.space_unemployed);

      var pie = d3.pie().sort(null);

      this.g_unemployed_ratio_1991
        .selectAll(".arc1991")
        .data(pie(this.data_unemployed_1991[0].values))
        .enter()
        .append("g")
        .attr("class", "arc1991")
        .append("path")
        .style("fill", (d, i) => {
          return this.color_for_unemployed_circle(i);
        })
        .transition()
        .delay(function (d, i) {
          return i * 300;
        })
        .duration(300)
        .attrTween("d", function (d) {
          var i = d3.interpolate(d.startAngle + 0.1, d.endAngle);
          return function (t) {
            d.endAngle = i(t);
            return arc(d);
          };
        });

      this.g_unemployed_ratio_1991
        .selectAll(".arc1991text")
        .data(pie(this.data_unemployed_1991[0].values))
        .enter()
        .append("g")
        .attr("class", "arc1991text")
        .append("text")
        .transition()
        .delay(function (d, i) {
          return i * 300;
        })
        .text(function (d) {
          return `${d.value.toPrecision(3)}%`;
        })
        .attr("transform", function (d) {
          return "translate(" + arc.centroid(d) + ")";
        })
        .style("text-anchor", "middle")
        .style("font-size", this.text_size)
        .style("opacity", this.opacity_value);
    },

    redraw_unemployed_pie_chart_2000() {
      // this.color_for_unemployed_circle = d3
      //   .scaleOrdinal()
      //   .domain(["no_worker", "unemployed_15_64", "unemployed_65"])
      //   .range(["#D8F3D0", "#B0E7DF", "#8BCDD3"]);
      // console.log("data2020:", this.current_data_unemployed_2000);

      var arc = d3
        .arc()
        .outerRadius(this.radius_unemployed_2000)
        .innerRadius(this.radius_unemployed_1991 + this.space_unemployed);

      var pie = d3.pie().sort(null);
      this.g_unemployed_ratio_2000.selectAll(".arc2000").remove();
      this.g_unemployed_ratio_2000.selectAll(".arc2000text").remove();

      var path_unemployed_pie_chart_2000 = this.g_unemployed_ratio_2000
        .selectAll(".arc2000")
        .data(pie(this.current_data_unemployed_2000));
      path_unemployed_pie_chart_2000
        .enter()
        .append("g")
        .attr("class", "arc2000")
        .append("path")
        .style("fill", (d, i) => {
          return this.color_for_unemployed_circle(i);
        })
        .transition()
        .delay(function (d, i) {
          return i * 300;
        })
        .duration(300)
        .attrTween("d", function (d) {
          var i = d3.interpolate(d.startAngle + 0.01, d.endAngle);
          return function (t) {
            d.endAngle = i(t);
            return arc(d);
          };
        });

      this.g_unemployed_ratio_2000
        .selectAll(".arc2000text")
        .data(pie(this.current_data_unemployed_2000))
        .enter()
        .append("g")
        .attr("class", "arc2000text")
        .append("text")
        .transition()
        .delay(function (d, i) {
          return i * 300;
        })
        .text(function (d) {
          return `${d.value.toPrecision(3)}%`;
        })
        .attr("transform", function (d) {
          return "translate(" + arc.centroid(d) + ")";
        })
        .style("text-anchor", "middle")
        .style("font-size", this.text_size)
        .style("opacity", this.opacity_value);

      this.g_unemployed_ratio_2000
        .exit()
        .transition() //🚧  explain
        .duration(750) //🚧  explain
        .style("opacity", 0) //🚧  explain
        .remove(); //🚧  explain
    },

    draw_unemployed_pie_chart_2000() {
      // this.color_for_unemployed_circle = d3
      //   .scaleOrdinal()
      //   .domain(["no_worker", "unemployed_15_64", "unemployed_65"])
      //   .range(["#D8F3D0", "#B0E7DF", "#8BCDD3"]);
      var arc = d3
        .arc()
        .outerRadius(this.radius_unemployed_2000)
        .innerRadius(this.radius_unemployed_1991 + this.space_unemployed);

      var pie = d3
        .pie()
        // .startAngle(1.1*Math.PI)
        // .endAngle(3.1*Math.PI)
        .sort(null);
      // .sort(function (a, b) { return d3.ascending(a.key, b.key) })

      this.g_unemployed_ratio_2000
        .selectAll(".arc2000")
        .data(pie(this.data_unemployed_2000[0].values))
        .enter()
        .append("g")
        .attr("class", "arc2000")
        .append("path")
        .style("fill", (d, i) => {
          return this.color_for_unemployed_circle(i);
        })
        .transition()
        .delay(function (d, i) {
          return i * 300;
        })
        .duration(300)
        .attrTween("d", function (d) {
          var i = d3.interpolate(d.startAngle + 0.1, d.endAngle);
          return function (t) {
            d.endAngle = i(t);
            return arc(d);
          };
        });

      this.g_unemployed_ratio_2000
        .selectAll(".arc2000text")
        .data(pie(this.data_unemployed_2000[0].values))
        .enter()
        .append("g")
        .attr("class", "arc2000text")
        .append("text")
        .transition()
        .delay(function (d, i) {
          return i * 300;
        })
        .text(function (d) {
          return `${d.value.toPrecision(3)}%`;
        })
        .attr("transform", function (d) {
          return "translate(" + arc.centroid(d) + ")";
        })
        .style("text-anchor", "middle")
        .style("font-size", this.text_size)
        .style("opacity", this.opacity_value);
    },

    redraw_unemployed_pie_chart_2010() {
      // this.color_for_unemployed_circle = d3
      //   .scaleOrdinal()
      //   .domain(["no_worker", "unemployed_15_64", "unemployed_65"])
      //   .range(["#D8F3D0", "#B0E7DF", "#8BCDD3"]);
      // console.log("data2010:", this.current_data_unemployed_2010);

      var arc = d3
        .arc()
        .outerRadius(this.radius_unemployed_2010)
        .innerRadius(this.radius_unemployed_2000 + this.space_unemployed);

      var pie = d3.pie().sort(null);
      this.g_unemployed_ratio_2010.selectAll(".arc2010").remove();
      this.g_unemployed_ratio_2010.selectAll(".arc2010text").remove();

      var path_unemployed_pie_chart_2010 = this.g_unemployed_ratio_2010
        .selectAll(".arc2010")
        .data(pie(this.current_data_unemployed_2010));
      path_unemployed_pie_chart_2010
        .enter()
        .append("g")
        .attr("class", "arc2010")
        .append("path")
        .style("fill", (d, i) => {
          return this.color_for_unemployed_circle(i);
        })
        .transition()
        .delay(function (d, i) {
          return i * 300;
        })
        .duration(300)
        .attrTween("d", function (d) {
          var i = d3.interpolate(d.startAngle + 0.01, d.endAngle);
          return function (t) {
            d.endAngle = i(t);
            return arc(d);
          };
        });

      this.g_unemployed_ratio_2010
        .selectAll(".arc2010text")
        .data(pie(this.current_data_unemployed_2010))
        .enter()
        .append("g")
        .attr("class", "arc2010text")
        .append("text")
        .transition()
        .delay(function (d, i) {
          return i * 300;
        })
        .text(function (d) {
          return `${d.value.toPrecision(3)}%`;
        })
        .attr("transform", function (d) {
          return "translate(" + arc.centroid(d) + ")";
        })
        .style("text-anchor", "middle")
        .style("font-size", this.text_size)
        .style("opacity", this.opacity_value);

      this.g_unemployed_ratio_2010
        .exit()
        .transition() //🚧  explain
        .duration(750) //🚧  explain
        .style("opacity", 0) //🚧  explain
        .remove(); //🚧  explain
    },

    draw_unemployed_pie_chart_2010() {
      // this.color_for_unemployed_circle = d3
      //   .scaleOrdinal()
      //   .domain(["no_worker", "unemployed_15_64", "unemployed_65"])
      //   .range(["#D8F3D0", "#B0E7DF", "#8BCDD3"]);
      var arc = d3
        .arc()
        .outerRadius(this.radius_unemployed_2010)
        .innerRadius(this.radius_unemployed_2000 + this.space_unemployed);

      var pie = d3
        .pie()
        // .startAngle(1.1*Math.PI)
        // .endAngle(3.1*Math.PI)
        .sort(null);
      // .sort(function (a, b) { return d3.ascending(a.key, b.key) })

      this.g_unemployed_ratio_2010
        .selectAll(".arc2010")
        .data(pie(this.data_unemployed_2010[0].values))
        .enter()
        .append("g")
        .attr("class", "arc2010")
        .append("path")
        .style("fill", (d, i) => {
          return this.color_for_unemployed_circle(i);
        })
        .transition()
        .delay(function (d, i) {
          return i * 300;
        })
        .duration(300)
        .attrTween("d", function (d) {
          var i = d3.interpolate(d.startAngle + 0.1, d.endAngle);
          return function (t) {
            d.endAngle = i(t);
            return arc(d);
          };
        });

      this.g_unemployed_ratio_2010
        .selectAll(".arc2010text")
        .data(pie(this.data_unemployed_2010[0].values))
        .enter()
        .append("g")
        .attr("class", "arc2010text")
        .append("text")
        .transition()
        .delay(function (d, i) {
          return i * 300;
        })
        .text(function (d) {
          return `${d.value.toPrecision(3)}%`;
        })
        .attr("transform", function (d) {
          return "translate(" + arc.centroid(d) + ")";
        })
        .style("text-anchor", "middle")
        .style("font-size", this.text_size)
        .style("opacity", this.opacity_value);
    },

    redraw_unemployed_pie_chart_2019() {
      // this.color_for_unemployed_circle = d3
      //   .scaleOrdinal()
      //   .domain(["no_worker", "unemployed_15_64", "unemployed_65"])
      //   .range(["#D8F3D0", "#B0E7DF", "#8BCDD3"]);
      // console.log(this.current_data_unemployed_2019);

      var arc = d3
        .arc()
        .outerRadius(this.radius_unemployed_2019)
        .innerRadius(this.radius_unemployed_2010 + this.space_unemployed);

      var pie = d3.pie().sort(null);
      this.g_unemployed_ratio_2019.selectAll(".arc2019").remove();
      this.g_unemployed_ratio_2019.selectAll(".arc2019text").remove();

      var path_unemployed_pie_chart_2019 = this.g_unemployed_ratio_2019
        .selectAll(".arc2019")
        .data(pie(this.current_data_unemployed_2019));
      path_unemployed_pie_chart_2019
        .enter()
        .append("g")
        .attr("class", "arc2019")
        .append("path")
        .style("fill", (d, i) => {
          return this.color_for_unemployed_circle(i);
        })
        .transition()
        .delay(function (d, i) {
          return i * 300;
        })
        .duration(300)
        .attrTween("d", function (d) {
          var i = d3.interpolate(d.startAngle + 0.01, d.endAngle);
          return function (t) {
            d.endAngle = i(t);
            return arc(d);
          };
        });

      this.g_unemployed_ratio_2019
        .selectAll(".arc2019text")
        .data(pie(this.current_data_unemployed_2019))
        .enter()
        .append("g")
        .attr("class", "arc2019text")
        .append("text")
        .transition()
        .delay(function (d, i) {
          return i * 300;
        })
        .text(function (d) {
          return `${d.value.toPrecision(3)}%`;
        })
        .attr("transform", function (d) {
          return "translate(" + arc.centroid(d) + ")";
        })
        .style("text-anchor", "middle")
        .style("font-size", this.text_size)
        .style("opacity", this.opacity_value);

      this.g_unemployed_ratio_2019
        .exit()
        .transition() //🚧  explain
        .duration(750) //🚧  explain
        .style("opacity", 0) //🚧  explain
        .remove(); //🚧  explain
    },

    draw_unemployed_pie_chart_2019() {
      // this.color_for_unemployed_circle = d3
      //   .scaleOrdinal()
      //   .domain(["no_worker", "unemployed_15_64", "unemployed_65"])
      //   .range(["#D8F3D0", "#B0E7DF", "#8BCDD3"]);
      var arc = d3
        .arc()
        .outerRadius(this.radius_unemployed_2019)
        .innerRadius(this.radius_unemployed_2010 + this.space_unemployed);

      var pie = d3.pie().sort(null);

      this.g_unemployed_ratio_2019
        .selectAll(".arc2019")
        .data(pie(this.data_unemployed_2019[0].values))
        .enter()
        .append("g")
        .attr("class", "arc2019")
        .append("path")
        .style("fill", (d, i) => {
          return this.color_for_unemployed_circle(i);
        })
        .transition()
        .delay(function (d, i) {
          return i * 300;
        })
        .duration(300)
        .attrTween("d", function (d) {
          var i = d3.interpolate(d.startAngle + 0.1, d.endAngle);
          return function (t) {
            d.endAngle = i(t);
            return arc(d);
          };
        });
      this.g_unemployed_ratio_2019
        .selectAll(".arc2019text")
        .data(pie(this.data_unemployed_2019[0].values))
        .enter()
        .append("g")
        .attr("class", "arc2019text")
        .append("text")
        .transition()
        .delay(function (d, i) {
          return i * 300;
        })
        .text(function (d) {
          return `${d.value.toPrecision(3)}%`;
        })
        .attr("transform", function (d) {
          return "translate(" + arc.centroid(d) + ")";
        })
        .style("text-anchor", "middle")
        .style("font-size", this.text_size)
        .style("opacity", this.opacity_value);
    },
  },
};
</script>

<style scoped>
</style>